import { useInfoDrawer } from 'context/InfoDrawerContext';
import { useEffect } from 'react';
import { DemandMonitoringCategoryInfoContent } from 'pages/insights-pro/performance-tab/reports/demand-monitoring/DemandMonitoringCategoryInfoContent';
import { Outlet } from 'react-router-dom';
import { useTransitiveCacheStore } from 'hooks/state/useTransitiveCacheStore';

export function DemandMonitoringReport() {
  const { setContent } = useInfoDrawer();

  const transitiveCacheStore = useTransitiveCacheStore();

  useEffect(() => {
    transitiveCacheStore.hideFilter('dateRange');
    transitiveCacheStore.hideFilter('comparisonDateRange');

    return () => {
      transitiveCacheStore.showFilter('dateRange');
      transitiveCacheStore.showFilter('comparisonDateRange');
      transitiveCacheStore.enableAllFilters();
    };
  }, []);

  useEffect(() => {
    const categoryDashboardInfo = {
      titleKey: 'demand.info.title',
      subtitleKey: 'info.content.all_dates_utc',
      content: <DemandMonitoringCategoryInfoContent />,
    };

    setContent(categoryDashboardInfo);

    return () => {
      setContent(null);
    };
  }, [setContent]);

  return <Outlet />;
}
